import {
    createAction,
    props
} from '@ngrx/store';

import { IDatiqUserResources } from '@dat/datiq-core/models';
import { DATIQ_USER } from '../models';
import {
    IDatiqUser,
    IDatiqUserModals,
    IDatiqUserUiState,
} from '../models/datiq-user.interface';

const createActionName: (name: string) => string = (name: string) => {
    return `[${DATIQ_USER}] ${name}`;
};



export const init = createAction(createActionName('Init'));
export const login = createAction(createActionName('Log In'));
export const logout = createAction(createActionName('Log Out'));
export const logoutSuccess = createAction(
    createActionName('Log Out - Success')
);
export const logoutFail = createAction(createActionName('Log Out - Fail'));
export const loginSuccess = createAction(
    createActionName('Log In - Success'),
    props<{ user: IDatiqUser }>()
);
export const loginFail = createAction(
    createActionName('Log In - Fail'),
    props<{ error: any }>()
);

export const showAgain = createAction(
    createActionName('Show Again Modal'),
    props<{ modalId: string; state: boolean }>()
);
export const showAgainSuccess = createAction(
    createActionName('Show Again Modal - Success'),
    props<{ modals: IDatiqUserModals; modalId: string }>()
);
export const showAgainFail = createAction(
    createActionName('Show Again Modal - Fail'),
    props<{ error: any }>()
);

export const viewModal = createAction(
    createActionName('View Modal'),
    props<{ modalId: string }>()
);
export const cacheUI = createAction(
    createActionName('Cache UI'),
    props<{ uiId: string; uiSettings: unknown }>()
);
export const cacheUISuccess = createAction(
    createActionName('Cache UI Success'),
    props<{ uiId: string; uiSettings: unknown }>()
);
export const cacheUIFail = createAction(
    createActionName('Cache UI Fail'),
    props<{ err: unknown }>()
);
export const updateUserCache = createAction(
    createActionName('Update User Cache'),
    props<{ userUiState: IDatiqUserUiState }>()
);

export const refreshUserResources = createAction(
    createActionName('refresh user resources')
);
export const updateUserResources = createAction(
    createActionName('update user resources'),
    props<{ resources: IDatiqUserResources }>()
);
